import { render, staticRenderFns } from "./CurationListRequestLayout.vue?vue&type=template&id=41f4d93e&scoped=true&"
import script from "./CurationListRequestLayout.vue?vue&type=script&lang=js&"
export * from "./CurationListRequestLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f4d93e",
  null
  
)

export default component.exports